var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('UserIcon',{staticClass:"float-md-right icon"}),_c('NotificationIcon',{staticClass:"float-md-right icon"}),_c('ChatIcon',{staticClass:"float-md-right icon",attrs:{"isInSideBar":_vm.isInSideBar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }